mutation CreateDataUploadRowRecord($id: ID!) {
  createDataUploadRowRecord(input: { id: $id }) {
    success
  }
}
